
import React from 'react';
import { MapPin, Home, Users, TreePine } from 'lucide-react';
import ComingSoonLayout from '../components/layout/ComingSoonLayout';

const Desa: React.FC = () => {
  return (
    <ComingSoonLayout
      title="Desa Karangmalang"
      subtitle="Profile & Informasi Desa"
      description="Halaman ini akan menampilkan profil lengkap Desa Karangmalang, termasuk sejarah, demografi, potensi desa, struktur pemerintahan, dan informasi geografis yang menarik."
      icon={<MapPin className="h-12 w-12 sm:h-16 sm:w-16 text-white" />}
     
      estimatedDate="Coming Soon"
    />
  );
};

export default Desa;